import Immutable from 'immutable';

import { resetBrandStyleOnRelation } from 'modules/Lexical/TextRelationStyles/resetBrandStyleOnRelation';
import { Styles } from 'const';
import * as Models from 'models';
import { isDefaultBrandStyleAvailable } from 'utils/brandStyles';
import { matchAppliedStylesWithBrandStyle } from './matchAppliedStylesWithBrandStyle';
import { resetBrandStyleOnComponent } from './resetBrandStyleOnComponent';

/**
 * Saves applied styles everywhere if it's possible and applies default brand styles where no chance to save applied styles
 * Reset styles, if the default brand styles are not available
 * As a result, mutates styles of the text relation
 */
export const matchAppliedStylesWithDefaultStylesIfPossible = (
  textRelationStyles: Models.TextRelationStyles,
  textComponent: Models.TextComponent,
  brandStyles: Models.BrandStylesMap,
  sectionStyles: Immutable.List<string>,
  colors: Models.BrandColorsList,
  fonts: Models.BrandFontsList,
): [Models.TextRelationStyles, Models.TextComponent] => {
  if (isDefaultBrandStyleAvailable(brandStyles, sectionStyles)) {
    const defaultBrandStyle = brandStyles.get(Styles.DefaultTextBrandStyle);

    return matchAppliedStylesWithBrandStyle(textRelationStyles, textComponent, defaultBrandStyle, colors, fonts);
  } else {
    return [
      resetBrandStyleOnRelation(textRelationStyles, colors),
      resetBrandStyleOnComponent(textComponent, colors, fonts),
    ];
  }
};
